// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__22SdM","colLarge":"styles_colLarge__fF3i2","col":"styles_col__1VkwO","colCheckbox":"styles_colCheckbox__2f0jB","actions":"styles_actions__416Ei"};